import { useState, useCallback } from "react";
import { expenseService } from "../services/expenseService";

export function useExpenses() {
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ from: "", to: "", expenseType: "", employeeId: "" });

  const loadExpenses = useCallback(async (customFilters) => {
    setLoading(true);
    setError(null);
    try {
      const res = await expenseService.getExpenses(customFilters ?? filters);
      setExpenses(res?.data || []);
    } catch {
      setError("حدث خطأ أثناء جلب المصروفات");
    } finally {
      setLoading(false);
    }
  }, [filters]);

  const addExpense = async (data) => {
    const res = await expenseService.addExpense(data);
    await loadExpenses();
    return res;
  };

  const updateExpense = async (id, data) => {
    const res = await expenseService.updateExpense(id, data);
    await loadExpenses();
    return res;
  };

  const removeExpense = async (id) => {
    await expenseService.deleteExpense(id);
    setExpenses((prev) => prev.filter((exp) => exp.id !== id));
  };

  return {
    expenses, loading, error, filters, setFilters,
    loadExpenses, addExpense, updateExpense, removeExpense,
  };
}